import React, {useContext, Suspense} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {authRoutes, publicRoutes} from "./routes";
import {SHOP_ROUTE} from "./utils/consts";
import {Context} from "./index";
import {observer} from "mobx-react-lite";
import Loading from "./components/commons/Loading/Loading"; // Используем ваш компонент Loading

const AppRouter = observer(() => {
    const {user} = useContext(Context);
    return (
        <Suspense fallback={<Loading />}> {/* Добавлен Suspense */}
            <Switch>
                {user.isAuth && authRoutes.map(({path, Component}) =>
                    <Route
                        key={path}
                        path={path}
                        render={(props) => <Component {...props}/>}
                        exact
                    />
                )}
                {publicRoutes.map(({path, Component}) =>
                    <Route
                        key={path}
                        path={path}
                        render={(props) => <Component {...props}/>}
                        exact
                    />
                )}
                <Redirect to={SHOP_ROUTE}/>
            </Switch>
        </Suspense>
    );
});

export default AppRouter;